import CheckIcon from '@mui/icons-material/Check';
import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import ReplayIcon from '@mui/icons-material/Replay';
import RemoveIcon from '@mui/icons-material/Remove';
import ClearIcon from '@mui/icons-material/Clear';

export enum IconType {
  CHECK,
  PLUS,
  MINUS,
  RELOAD,
  DOWNLOAD,
  CLEAR,
}
export type BasicIconProps = {
  type: IconType;
};

const iconTypeToIconMap = {
  [IconType.CHECK]: CheckIcon,
  [IconType.PLUS]: AddIcon,
  [IconType.MINUS]: RemoveIcon,
  [IconType.RELOAD]: ReplayIcon,
  [IconType.DOWNLOAD]: DownloadIcon,
  [IconType.CLEAR]: ClearIcon,
};

const BasicIcon = ({ type }: BasicIconProps) => {
  const Icon = iconTypeToIconMap[type];
  return <Icon />;
};

export { BasicIcon };
